import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Size from './Size';
import OptionGroups from './OptionGroups';
import {updateBasketItemSize, updateBasketItemOptions} from '../../actions/basketItem.action';
import {OptionGroupStyled} from './OptionGroups.style';

export class MealOptions extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedSize: props.selectedSizeIndex
    };
    this.selectSize = this.selectSize.bind(this);
    this.updateOptionGroup = this.updateOptionGroup.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return this.props.sizes[this.state.selectedSize] !== nextProps.selectedSize;
  }

  selectSize(size) {
    if (size !== this.state.selectedSize) {
      this.setState({ selectedSize: size});
      this.props.updateBasketItemSize(this.props.sizes[size]);
    }
  }

  updateOptionGroup(selectedOptions, multiSelect, isMaxSelectableOne) {
    this.props.updateBasketItemOptions({
      selectedOptions,
      basicPrice: this.props.sizes[this.state.selectedSize].price,
      multiSelect,
      isMaxSelectableOne
    });
  }

  render() {
    const {sizes, selectedSize, basketItemUuid, selectedOptions, basketModalMode, selectedSizeIndex} = this.props;
    const selected = this.state.selectedSize;
    const renderSizes = sizes.length > 1 &&
      <OptionGroupStyled>
        {
          sizes.map((size, index) =>
            <Size
              key={size.name}
              name={size.name}
              price={size.price}
              index={index}
              callback={this.selectSize}
              selectedSize={selectedSize}
            />)
        }
        </OptionGroupStyled>;
    const optionGroups = sizes[selected] && sizes[selected].optionGroups &&
      <OptionGroups
        optionGroups={sizes[selected].optionGroups}
        updateOptionGroups={this.updateOptionGroup}
        selectedOptions={selectedOptions}
        basketItemUuid={basketItemUuid}
        basketModalMode={basketModalMode}
        selectedSizeChanged={selected !== selectedSizeIndex}
      />;

    return (
      <div data-rw="meal-size-options">
        {renderSizes}
        {optionGroups}
      </div>
    );
  }
}

MealOptions.propTypes = {
  sizes: PropTypes.array.isRequired,
  selectedSize: PropTypes.string,
  updateBasketItemSize: PropTypes.func.isRequired,
  updateBasketItemOptions: PropTypes.func.isRequired,
  selectedOptions: PropTypes.array,
  selectedSizeIndex: PropTypes.number,
  basketItemUuid: PropTypes.string,
  basketModalMode: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    selectedSize: state.basketItem.size
  };
}

const mapDispatchToProps = dispatch => {
  return {
    updateBasketItemSize: bindActionCreators(updateBasketItemSize, dispatch),
    updateBasketItemOptions: bindActionCreators(updateBasketItemOptions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MealOptions);



// WEBPACK FOOTER //
// ./components/Meal/MealOptions.js